import { MarketType } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const marketTypeDictionary = createSimpleDictionary([
    { id: MarketType.OneXTwo, name: 'dictionaries.marketType.oneXTwo' },
    { id: MarketType.Handicap, name: 'dictionaries.marketType.handicap' },
    { id: MarketType.Goal, name: 'dictionaries.marketType.goal' },
    { id: MarketType.Bts, name: 'dictionaries.marketType.bts' },
    { id: MarketType.Dc, name: 'dictionaries.marketType.dc' },
    { id: MarketType.Cs, name: 'dictionaries.marketType.cs' },
    { id: MarketType.CornersHandicap, name: 'dictionaries.marketType.cornersHandicap' },
    { id: MarketType.CornersGoal, name: 'dictionaries.marketType.cornersGoal' },
]);
